module.exports = __webpack_public_path__ + "img/Ptuapp6.25d058e1.png";